const en = {
  requirementList: 'Requirement List',
  material: 'Material control',
  purchase: 'Procurement',
  prod: 'Production',
  finance: 'Finance',
  sale: 'Business',
  materialStatus: 'Material control audit status',
  purchaseStatus: 'Procurement review status',
  prodStatus: 'Production audit status',
  financeStatus: 'Financial audit status',
  saleStatus: 'Business review status',
  materialDesc: 'Material control audit notes',
  purchaseDesc: 'Purchase audit notes',
  prodDesc: 'Production audit notes',
  financeDesc: 'Financial audit notes',
  saleDesc: 'Business audit notes',

  commodity: 'Product',
  commodityStatus: 'Product Review Status',
  commodityDesc: 'Product Review Remarks',

  passed: 'Passed',
  notPass: 'Failed',
  approvalTip: 'Please enter the review comments',
  listSearchTip: 'Enter the number, description, and product information to search',

  number: 'Number',
  bomAmount: 'Usage',
  requireCount: 'Required quantity',
  itemCountInfo: 'Number of required items',
  materialProgress: 'Material preparation progress',
  mrd: 'Request for material completion time',
  plMrd: 'Please fill in the required material delivery time first',
  mcPre: 'Material control spare parts quantity',
  bomData: 'Total standard quantity',
  estimatedCost: 'Estimated cost',
  passStatus: 'Approval status',

  errorTip: 'Error message',
  errorDesc: 'There are data anomalies in the table. Are you sure you want to submit without making any modifications',
  noRepl: 'There are currently no alternative materials available',
  selectRepl: 'Select alternative materials',
  allCount: 'The total quantity has been rounded up, you can modify the total usage according to the actual situation',

  matchBom: 'Match Bom table',
  editQuantity: 'Modify quantity',
  matchInventory: 'Match inventory',
  alrPreOutNum: 'Already Pre-outbound Quantity',
  preOut: 'Pre release',
  confirmPickOut: 'When the current pre-outbound quantity is less than the actual available outbound quantity, the picking list will be generated based on the actual available outbound quantity. Generate the pre-outbound order?',
  prePickOut: 'Generate Pre-outbound Order',
  prePickOutNum: 'Current Pre-outbound Quantity',
  actualOutNum: 'Actual Available Outbound Quantity',
  confirmPro: 'Determine material data',
  addDesc: 'Add a note',
  done: 'Completed',
  doneSuccess: 'Successfully generated requirement list',
  doneSuccessTip: 'The demand list {{number}} has been generated and the relevant business will continue with the next steps of operation',
  next: 'Next',
  previous: 'Back',
  requirementAdd: 'Generate a demand list',
  selectPro: 'Select product',
  searchPro: 'Enter product keywords to search',

  detail: 'Requirement list details',
  orderDetail: 'Order details',

  purCount: 'Quantity to be purchased',
  purEdCount: 'Quantity to be purchased',
  preInCount: 'Quantity to be pre-stocked',
  preOutCount: 'Quantity to be pre-stocked',
  minPrice: 'Minimum unit price',
  maxPrice: 'Maximum unit price',
  minCost: 'Minimum cost',
  maxCost: 'Maximum cost',
  supplierAndPrice: 'Supplier and price selection',
  addPurDesc: 'Add purchase description',

  notApproved: 'Not approved yet',

  requirementAppInfo: 'Requirement list review information',
  eps: 'Expected launch date',
  plEps: 'Please fill in the expected launch time',
  saveTemp: 'Save template',
  saveTempSuccess: 'Template added successfully',
  useQuantity: 'Quantity used per item',
  addConfirm: 'Are you sure you want to add this request form',
  selectProdPro: 'Select production mother parts',
  plSelectProdPro: 'Please select the mother piece to be produced',
  product: 'Mother piece',
  prodCount: 'Production quantity',
  plProdCount: 'Please enter the production quantity',
  desc: 'Requirement List Remarks',
  plDesc: 'Please enter the requirement list remarks',
  plSubPro: 'Select sub item information',
  tempSuccess: 'Template created successfully',
  validError: 'Verification error',
  addRequirement: 'Add requirement list',
  total: 'Total',
  success: 'Success',
  failed: 'Failed',
  exportExcel: 'Export to Excel',
  requirementCreate: 'Generate a demand list',
  mainInfo: 'Main piece information',
  flow: 'Approval process',
  delSubTip: 'Are you sure you want to delete the selected sub item? Cannot be restored after deletion',
  syncClearRequirementItems: 'Sync clear requirement items',
  syncClearRequirementItemsTip: 'Are you sure you want to delete all requirement items under the current requirement list? They cannot be restored after deletion',
  delOrderItemTip: 'Delete the corresponding picking order?',
  delPurchaseOrderItemTip: 'Delete the corresponding purchase order?',
  selectAll: 'Select all',
  oked: 'Passed',
  pending: 'Pending',
  rejected: 'Rejected',
  rejectTip: 'Are you sure you want to reject this list of requirements? After rejection, it will return to the previous step of the business operation',
  rejectReason: 'Reason for rejection',
  rejectReasonRequired: 'Please enter reason for rejection',
  rejectReasonPlaceholder: 'Please provide detailed reason for rejection...',
  rejectReasonMaxLength: 'Reason cannot exceed 500 characters',
  closeTip: 'Are you sure you want to archive this requirement list? After archiving, the data cannot be changed',
  supplier: 'Supplier',
  ert: 'Expected delivery time',
  supplierPriceNo: 'There are currently no supplier prices available',
  surOk: 'The purchase order has been successfully added. Please filter the page to view it',
  surSure: 'Please confirm if there is any purchasable data available',
  reject: 'Refuse',
  close: 'Close',
  saleNum: 'Sales quantity',
  prNum: 'Production quantity',
  plPrNum: 'Please enter the production quantity',
  orderAlready: 'This order has generated a demand form',
  orderDate: "Order Date",
  pricePreview: ' Product Price Preview',
  endError: "Are you sure this order has been completed?",
  plSeSupplier: "Select supplier",
  plPlacePrice: "Select order price",
  noPurchaseTip: "No data available for purchase",
  okPurchase: "Confirm purchase",

  onKeyQutote: "One click inquiry",
  subQutote: "Inquiry in batches",
  onKeyPrice: "One click inquiry",
  subPrice: "Batch Inquiry",
  onKeyPurchese: "One click generation of pre purchase order",
  sendQutote: "Inquiry form has been sent",
  sendQutotePro: 'Inquiry requests for {{len}} projects have been sent',
  ddl: "Deadline",
  noSupplier: "There are currently no suppliers available to send inquiry forms",
  qutoteSednFail: 'Sending inquiry form failed',
  autoPurcheseSucc: "The automatic generation of pre purchase orders was successful, but some materials did not have valid quotations and could not generate pre purchase orders",
  supplierProgress: "Supplier Feedback Progress",
  unRead: "unread",
  read: 'already read',
  unPriced: "To be quoted",
  resolved: 'Quoted',
  qutotationProgress: "Inquiry Form Progress Details",
  matInfo: "Material Information",
  requirementInfo: "Quotation Information",
  requirementHelp: "Assist with quoting",
  supplierQuote: "Supplier Quote",
  status: "Status",
  days: "Supply cycle",
  mpq: "Minimum Packaging",
  supplierTime: "Material Preparation Time",
  edit: "Edit",
  resped: "Feedback received",
  unResp: 'No feedback',
  rulePrice: "Contract Price",
  ruleDays: "Contract Supply Cycle",
  ruleMpq: "Minimum packaging for contracts",
  price: "price",
  inputPrice: "Please enter the price",
  priceTip: "Tip: If the quotation is higher than the contract price, it may result in the quotation being invalid",
  inputDays: "Please enter the supply cycle",
  daysTip: "Reminder: If the supply cycle is longer than the contract supply cycle, it may cause the quotation to be invalid",
  mpqTip: "Tip: If the minimum packaging quantity is greater than the minimum packaging quantity in the contract, it may result in invalid quotation",
  inputSuppTime: "Please enter the time for material completion",
  addSuppQutoteTip: "This supplier already has an inquiry form, no need to add it",
  addSuppQutote: "Add Supplier Quotation",

  inputMpq: "Please enter the minimum packaging",
  ddlTime: "Latest delivery time",
  inputDdlTime: "Please enter the latest delivery time",
  ddlTimeTip: "Tip: The latest delivery time exceeds the required material delivery time, which may result in invalid quotation",
  prevDMrd: "Estimated delivery time",
  deadline: "Latest submission time",

  nuRead: "Unread",
  timedOut: 'Already overdue',
  day: "day",
  hour: "Hour",
  purTip: "Are you sure you want to generate a pre-purchase order?",
  purContent: "This will automatically generate a pre-purchase order",

  salePrice: "Sales amount",
  mateCost: "Material cost",
  notCount: "Not calculated",
  netProfit: "Net profit",
  goPur: "Generate Purchase Order",

  lazyQuota: 'Delayed Quotation',
  lazyQuotaErr: 'Delayed quotation failed',
  lazyQuotaSuc: 'Delayed quotation successful',
  lazyTime: 'Select or enter the time period to be delayed',
  curLazy: 'Current quotation deadline',

  notSelect: 'Some materials do not have valid quotations. Please ensure that each material has a valid quotation before proceeding with the approval',
  notSelectTip: 'There is no valid quotation for the following materials.',
  purchaseProgress: "Purchase Order Progress",
  quotationProgress: "Inquiry form sending progress",
  noQuotationTip: 'There is no valid quotation for the highlighted material',
  searchPlaceHolder: 'Enter supplier or product information query',
  allQuotation: 'All Inquiry Sheets',
  purchaseOrders: 'Purchase Orders',
  prePurchaseOrders: 'Pre purchase orders',
  preview: 'Preview',
  toGen: 'To be generated',


  unapprove: 'Pending review',
  approved: 'Reviewed',
  timed: 'expired',
  updatePrice: 'Modify quotation',
  rePrice: 'requote',
  quotation: 'Quotation approval',
  reSelect: 'Manual Selection',
  selected: 'Selected',
  reSelecteDone: 'Reselected',
  reSelecteFail: 'Reselection failed',
  createPreOutInventory: 'Generate pre-outbound order',
  createPreOutInventoryCon: "Confirm to generate material requisition outbound order?",
  createPreOutInventorySuccess: 'Generate pre-outbound order successfully',
  createPreOutInventoryFail: 'Generate pre-outbound order failed',
  noPreOutInventory: 'No available inventory',
  pleaseSelect: 'Please select material',
  preOutInventory: 'Pre-outbound order',
  goodsName: 'Material name',
  availableQuantity: 'Available quantity',
  outboundType: 'Type of outbound order',
  inCount: 'Inventory quantity',
  outCount: 'Outbound quantity',
  shouldOutCount: 'Planned outbound quantity',
  actualOutCount: 'Actual outbound quantity',
  requirmentQuantity: 'Quantity of demand orders',
  preReadyGood: 'Pre-ready material does not need to be outbound',
  outInventory: 'Outbound order',
  notQuo: "No Quotation Needed",
  notPur: "No Purchase Needed",
  curMrd: "Current Delivery Time",
  selMrd: "Select Final Delivery Time",
  finalMrd: "Final Delivery Time",
  mrdEdit: "Estimated Delivery Time Adjustment",
  quoEdit: "Enquiry Modification",
  closeReq: "Close Demand Order",
  editNum: "Edit Demand List Quantity",
  plReqCount: "Please enter the required quantity",
  plPurCount: "Please enter the quantity to be purchased",
  purCountErr: "Purchase quantity must be less than required quantity",
  bomAmountErr: "Please enter a valid BOM amount",
  quantityAndBomAmount: "Quantity and usage cannot be empty or 0",
  skipStock: "Skip inventory matching (no pre-outbound)",
  overInventoryTip: "Note: Red highlighted data indicates pre-outbound quantity exceeds current inventory quantity",
  skipMerge: "Merge identical materials (identical materials are merged, quantities are summed)",
  finalPurQuantity: "Final Purchase Quantity",
  quotationTip: "The quotation cannot be modified after submission. Confirm to submit?",
  notAddCloseTip: "Materials have not been added yet. Are you sure you want to close?",
  confirmAddProduct: "Confirm Add Product Information",
  duplicateMaterialTip: "Highlighted materials indicate that there is another identical material",
  matching: "Matching...",
  documentGenerationFailed: "Document generation failed",
  printFailed: "Print failed",
  pdfGenerationFailed: "PDF generation failed",
  requirementListAll: "Requirement List_All",
  exportMatchResult: "Export Match Results",

  // MultiPurchaseSteps Batch Purchase Order
  multiPurchaseTitle: "Batch Purchase Order",
  selectSupplier: "Select Supplier",
  matchProduct: "Match Product",
  matchPrice: "Match Price",
  generatePurchase: "Generate Purchase Order",
  acceptPurchase: "Accept Purchase Order",
  complete: "Complete",
  nextStep: "Next",
  prevStep: "Previous",
  tip: "Tip",
  enterGenerateTip: "Cannot go back after entering the purchase order generation step",
  confirmClose: "Confirm to close?",
  closeTipContent: "Purchase orders have not been generated yet. Confirm to close?",

  // MatchProduct Match Product
  oneClickAddProduct: "Add Products in Bulk",
  addingProduct: "Adding products",
  processed: "Processed:",
  productsWithoutPrice: "Red-highlighted materials do not exist in the supplier system. You need to add these materials to the supplier system",
  noNeedAddProduct: "No need to add products",
  noNeedAddProductDesc: "There are no non-existent materials. No need to add",
  supplierApiError: "Supplier API error, please check",
  productMatchFailed: "Product match failed",
  productMatchFailedDesc: "Supplier API:",
  successAddProduct: "Successfully added",
  productAddFailed: "products, failed",
  oneClickAddPrice: "Add Prices in Bulk",
  addingPrice: "Adding prices",
  productsWithoutPriceTip: "Red-highlighted materials do not have prices in the supplier system. You need to add prices for these materials to the supplier system",
  noNeedAddPrice: "No need to add prices",
  allProductsHavePrice: "All materials already have prices",
  supplierIdError: "Supplier ID error, please check",
  successAddPrice: "Successfully added",
  priceAddFailed: "prices, failed",

  // GeneratePurchase Generate Purchase Order
  oneClickOrder: "Place Order in Bulk",
  ordering: "Placing orders",
  successGeneratePurchase: "Successfully generated",
  purchaseOrder: "purchase orders",
  generatePurchaseFailed: "purchase orders, failed",
  purchaseOrderNumber: "Purchase Order Number",
  purchaseQuantity: "Purchase Quantity",
  orderStatus: "Order Status",
  ordered: "Ordered",
  finished: "Completed",
  notOrdered: "Not Ordered",
  acceptStatus: "Accept Status",
  accepted: "Accepted",
  oneClickAccept: "Accept in Bulk",
  accepting: "Accepting purchase orders",
  noData: "No data",
  noPurchaseOrderToAccept: "No purchase orders to accept",
  successAccept: "Successfully accepted",
  acceptFailed: "purchase orders, failed",
  noPurchaseDataTip: "Data that does not require purchase or has already generated pre-purchase orders will not be processed for purchase orders",
  swapSale: "Transfer",
  // SwapSaleOrder Transfer Order
  noDataToTransfer: "No data to transfer",
  noDataToTransferDesc: "Data that does not require purchase or has already generated pre-purchase orders will not be transferred",
  supplierApiLabel: "Supplier API: ",
  fetchOrgInfoFailed: "Failed to fetch organization information",
  orgLabel: "Organization: ",
  selectSupplierAndCustomer: "Please select supplier organization and end customer",
  noMatchedProductData: "No matched product data",
  saleOrderTransferSuccess: "Sales order transfer successful",
  saleOrderNumber: "Sales Order Number: ",
  saleOrderGenerateFailed: "Failed to generate sales order",
  selectSupplierFirst: "Please select supplier",
  selectSupplierOrg: "Please select supplier organization",
  selectSupplierCustomer: "Please select supplier end customer",
  confirmGenerateSaleOrder: "Confirm to generate sales order?",
  generateSaleOrderForSupplier: "Generate sales order for supplier: ",
  swapEnd: "Information matching failed, order transfer terminated.",
  noCustomerPrice: "The highlighted materials do not have this end customer price in the supplier system",
  plAddCustomerPrice: "Please go to the supplier system to add the material prices for this end customer",
  noProducts: "The highlighted materials do not exist in the supplier system",
  plAddProdictOne: "1. Go to the supplier system to add these material information",
  plAddProdictTwo: "2. Go to the supplier system to add the product prices for these materials",
  closeSaleOrderTip: "Do you want to delete the associated sales order:",
  plAddSupplierPrice: "The highlighted materials do not have this supplier price. Please maintain the supplier prices for these materials in this system first.",
  batchSelect: "Batch Select Enquiry",
  progress: "Progress",
  importQuotationExcel: "Import Quotation Excel",
  quotationImportPreview: "Supplier Quotation Import Preview",
  quotationImportRowNumber: "Row",
  quotationImportRequirementItemId: "Requirement Item ID",
  quotationImportSupplierCode: "Supplier Code",
  quotationImportSupplierName: "Supplier Name",
  quotationImportPrice: "Price",
  quotationImportMpq: "Minimum Pack",
  quotationImportStatus: "Status",
  quotationImportItemIdRequired: "Requirement item ID is required",
  quotationImportItemNotFound: "Requirement item ID does not exist or is no longer valid",
  quotationImportProductMismatch: "Requirement item ID does not match the inventory code",
  quotationImportSupplierRequired: "Supplier code is required",
  quotationImportSupplierLoadFailed: "Failed to load supplier data",
  quotationImportPriceInvalid: "Price must be a valid number greater than 0",
  quotationImportMpqInvalid: "Minimum pack must be a valid number greater than 0",
  quotationImportNoMrd: "The requirement has no MRD for the latest delivery time",
  quotationImportInvalidHeader: "Invalid headers. Please use the file exported from the current detail page",
  quotationImportFileEmpty: "The import file contains no processable data",
  quotationImportParseFailed: "Failed to parse the import file",
  quotationImportSubmitFailed: "Failed to add supplier quotation",
  quotationImportReady: "Ready",
  quotationImportReselect: "Choose Another File",
  quotationImportHasErrors: "Validation errors exist. Correct the Excel file and import it again",
  quotationImportSummary: "{{success}} succeeded, {{failed}} failed",
  salePass: "Convert to Formal Order",
  downloadTemplate: "Download Template",
  inputTemp: "Input from Template",
  importTemplate: "Requirement List Import Template",
  invalidTemplate: "Please select the correct template file",
  parseDataSuccess: "Successfully parsed {{count}} records",
  atLeastOnePreOutGreaterThanZero: "At least one pre-outbound quantity must be greater than 0",
  cusOrderQty: "Customer Order Quantity",
  cusOrderQtyTip: "Transfer Order",
  processFilter: "Search Material Process",
  delErrTip: "The following materials have outbound quantities and cannot be deleted!",
  mixReplaced: "Use Substitute Materials in Combination",
  preOutDesc: "Pre-outbound Remark",
  prePickOutLimitAutoTip: "Current pre-outbound quantity is automatically limited to the valid range",
  prePickOutRemainLimit: "Remaining pre-outbound quantity",
  prePickOutStockLimit: "Available inventory quantity",
  prePickOutMaxLimit: "Maximum fillable quantity",
  deductOutCount: "Deduct outbound quantity",
  inOrderDesc: "Delivery Note Remark",
  plInventoryDesc: "Please enter delivery note remark",
  noSale: "No source sales order, cannot transfer order", oldApprove: "Original Approval Order",
  newApprove: "New Approval Order",
  approveSaveTip: "Approving this enquiry will also save the new approval order",
  approveRemark: "Approval Remarks",
  matchLocType: "Inventory Matching Location Type",
  rematch: "Match Stock",
  rematchTip: "The stock location type has been changed. Please re-match stock.",
  priceFloor: "Purchase Order Price Rounding",
  needReturn: "Some outbound orders have been confirmed!",
  needReturnTip: "The requisition orders containing the following materials need to be returned to stock",
  bomDatax: "System BOM Data",
  templeData: "Template",
  xlsData: "Sales Order BOM File",
  dataTypeTip: "Select BOM data source for matching",
  dataTypeErr: "The BOM data of this sales order cannot be parsed",
  dataTypeErrTip: "Please check the BOM data of this sales order, or switch to another BOM data source",
  pickErr: "New pre-outbound order: {{number}} stock allocation failed, keep it?",
  pickErrTip: "Pre-outbound order: {{number}} generated successfully",
  pickErrContent: "Please allocate stock in warehouse management",
  pickErrDel: "Failed to generate pre-outbound order",
  itemDesc: "Material Remark",
  preOutErrTip: "Demand list {{number}} was generated successfully, but pre-outbound order generation failed. Please retry!",
  rePreOutAdd: "Retry Pre-outbound",
  failPreTip: "Failed to generate pre-outbound order for the demand order!",
  failPreTipDesc: "Failure to generate the pre-outbound order will cause incorrect quantities in the demand order! If you do not handle the pre-outbound failure, it is recommended to delete this demand order and run it again!",
};

export default en;
